import React from 'react'
import Box from '@zuto/core/src/box'
import { VehicleDetailsDataObject } from '../../../services/vehicle-service'
import { styled, Typography } from '@mui/material'


const StyledBlueBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  background: theme.customPalette.primary[90],
  borderRadius: '12px',
  textAlign: 'center'
}))

const StyledReg = styled('span')(({ theme }) => ({
  background: theme.customPalette.secondary[90],
  borderRadius: '6px',
  textAlign: 'center',
  padding: theme.spacing(1)
}))


interface VehicleInfoProps {
  vehicle: VehicleDetailsDataObject
}

const VehicleInfoRefinance = ({
  vehicle
}: VehicleInfoProps) => (
  <StyledBlueBox p={4} my={4}>
    <Typography variant="titleSmall" component="p" sx={{ mb: 4 }} data-testid="vehicle-reg" my={2}><StyledReg>{vehicle?.registration}</StyledReg></Typography>
    <Typography variant="titleSmall" component="p" sx={{ mb: 0 }} data-testid="vehicle-make">{vehicle.make}</Typography>
    <Typography variant="titleSmall" component="p" sx={{ mb: 0 }} data-testid="vehicle-model">{vehicle.model}</Typography>
    <Typography variant="titleSmall" component="p" sx={{ mb: 0 }} data-testid="vehicle-colour">{vehicle.colour}</Typography>
    <Typography variant="titleSmall" component="p" sx={{ mb: 0 }} data-testid="vehicle-fuelType">{vehicle.fuelType}</Typography>
  </StyledBlueBox>
)

export default VehicleInfoRefinance
